<template>
	<layoutSection :type="layoutSectionType">
		<template #main>
			<div class="bg-goPinkBrighter tabletWide:rounded-GO tabletWide:h-full tabletWide:py-32">
				<layoutPost type="center">
					<header class="space-y-16">
						<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{vehicle.international}}</h2>
						<slot name="afterInternational" :vehicle="vehicle" />
					</header>

					<div class="space-y-32">
						<div class="flex flex-row space-x-16 tabletWide:space-x-8 desktop:space-x-32">
							<ul class="space-y-8">
								<li v-for="(spec) in vehicle.specs.slice(0, 4)" :key="'li' + spec.text" class="space-x-4">
									<svg-icon v-if="!!spec.icon" :name="spec.icon" class="iconSize-24 text-goPink" />
									<span v-if="!!spec.text">{{ spec.text }}</span>
								</li>
							</ul>

							<ul class="space-y-8">
								<li v-for="(spec) in vehicle.specs.slice(4)" :key="'li' + spec.text" class="space-x-4">
									<svg-icon v-if="!!spec.icon" :name="spec.icon" class="iconSize-24 text-goPink" />
									<span v-if="!!spec.text">{{ spec.text }}</span>
								</li>
							</ul>
						</div>

						<ul class="space-y-4 text-14">
							<li v-for="(detail) in vehicle.details" :key="'li' + detail" class="space-x-4">
								<svg-icon name="chevron" class="iconSize-24 text-goPink" />
								<span> {{ detail }} </span>
							</li>
						</ul>

						<ul v-if="vehicle.extraDetails" class="space-y-4 text-14">
							<li v-for="(detail, index) in vehicle.extraDetails" :key="'li' + index" class="flex space-x-8">
								<svg-icon :name="detail.icon" class="iconSize-24 text-goPink" />
								<span v-html="detail.content" />
							</li>
						</ul>
					</div>

					<footer>
						<button type="button" class="button button-goPinkGhost button-normal" @click="() => $scrollTo('backToTop')">
							Enter itinerary for pricing
						</button>
					</footer>
					<div v-if="$store.getters['vehicle/dealsByClassCode'](vehicle.classCode).length" class="space-y-16">
						<hr class="border-1 border-goPinkBright/50" />

						<ul class="space-y-4 text-14">
							<li v-for="(deal) in $store.getters['vehicle/dealsByClassCode'](vehicle.classCode)" :key="'deal' + deal.hotDealInfo.hotDealId">
								<nuxt-link :to="{ name: deal.hotDealInfo.dealType === 'Relocation' ? 'rental-car-relocation' : 'deals', params: { scrollTarget: { Relocation: 'reloDeal', HotDeal: 'hotDeal', Promotion: 'promoDeal' }[deal.hotDealInfo.dealType] }}" class="flex items-center space-x-4 link" :class="deal.hotDealInfo.dealType === 'Relocation' ? 'link-goBlue' : 'link-goPink'">
									<svg-icon :name="{ Relocation: 'relo-deal', HotDeal: 'hot-deal', Promotion: 'promo-deal' }[deal.hotDealInfo.dealType]" class="iconSize-24" />
									<span> <b>{{ { Relocation: 'Relo deal', HotDeal: 'Hot deal', Promotion: 'Promo deal' }[deal.hotDealInfo.dealType] }}</b> {{ deal.hotDealInfo.discountText }}</span>
								</nuxt-link>
							</li>
						</ul>
					</div>
				</layoutPost>
			</div>
		</template>

		<template #aside_top>
			<figure class="h-full">
				<img src="/images/blank.svg" :data-src="$cloudFlare.getImage(vehicle.images[0].mobile.src)" width="900" height="450" decoding="async" :alt="vehicle.images[0].alt" class="object-cover w-full h-full overflow-hidden rounded-tr-16 lazyload" />
			</figure>
		</template>

		<template #grid>
			<figure v-for="(image, index) in vehicle.images.slice(1)" :key="'image' + index">
				<img src="/images/blank.svg" :data-src="$cloudFlare.getImage(image.mobile.src)" width="343" height="229" decoding="async" :alt="image.alt" class="object-cover w-full h-full overflow-hidden lazyload" :class="[{ 'rounded-bl-16': index === 2 }]" />
			</figure>
		</template>
	</layoutSection>
</template>

<script>
import layoutSection from "~/components/layoutSection.vue";
import layoutPost from "~/components/layoutPost.vue";

export default {
	components: {
		layoutSection,
		layoutPost,
	},
	props: {
		vehicle: {
			type: Object,
			required: true,
		},
		layoutSectionType: {
			type: String,
			default: "post-grid",
			required: true,
		},
	},
};
</script>
